import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              明智育儿指南
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.tagline}
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mt-2">
              科学理解管教，智慧陪伴成长。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                首页
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <a href={`mailto:${siteInfo.email}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                联系我们
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              联系方式
            </h4>
            <div className="text-sm text-foreground-600 space-y-2">
              <p className="whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-primary-500 transition-colors">
                  {siteInfo.email}
                </a>
              </p>
              <p className="whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>
                <a href={`tel:${siteInfo.phone}`} className="hover:text-primary-500 transition-colors">
                  {siteInfo.phone}
                </a>
              </p>
              <p>
                <i className="ri-map-pin-line mr-2"></i>
                {siteInfo.address}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 明智育儿指南. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            本站内容仅供参考，不构成专业医疗或心理咨询建议。
          </p>
        </div>
      </div>
    </footer>
  );
}